import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { CognitoServiceService } from '../services/auth/cognito-service.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: CognitoServiceService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Convertir la promesa de obtener el token en un Observable
    return from(this.getAuthToken()).pipe(
      switchMap(token => {
        // Si hay token, agregarlo al header Authorization
        if (token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }

        return next.handle(request);
      }),
      catchError((error: HttpErrorResponse) => {
        // Si el error es 401 (No autorizado), redirigir al login
        if (error.status === 401) {
          this.authService.logOut();
        }
        return throwError(() => error);
      })
    );
  }

  private async getAuthToken(): Promise<string | null> {
    try {
      // Obtener token válido (refrescar automáticamente si es necesario)
      return await this.authService.getValidToken();
    } catch (error) {
      console.error('Error obteniendo token de autenticación:', error);
      return null;
    }
  }
}
